import React, { Component } from "react";
import Message from "./../utilityComponents/Message";

export class AuthError extends React.Component {
    _goBackToPrevPage() {
        this.props.history.goBack();
    }
    render() {
        return (
            <div className="d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <h1 className="display-1 fw-bold" style={{ fontSize: "13rem" }}>
                        {this.props.errorResponse.response.status}
                    </h1>
                    <p className="lead">{this.props.errorResponse.response.data.message}</p>
                    {!this.props.privilegeError ? (
                        <a href="/" class="btn btn-primary">
                            Re-Login
                        </a>
                    ) : (
                        <a
                            className="btn btn-primary"
                            style={{ color: "white" }}
                            onClick={() => this._goBackToPrevPage()}
                        >
                            Previous Page
                        </a>
                    )}
                </div>
            </div>
        );
    }
}

export class PrivilegeError extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: props.error,
            errorMsg: "",
        };
    }
    componentWillMount() {
        // if(this.state.error.hasOwnProperty("response") && this.state.error.response.hasOwnProperty("data")
        //    && this.state.error.response.data.hasOwnProperty("message")){
        if (
            Object.prototype.hasOwnProperty.call(this.state.error, "response") &&
            Object.prototype.hasOwnProperty.call(this.state.error.response, "data") &&
            Object.prototype.hasOwnProperty.call(this.state.error.response.data, "message")
        ) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    errorMsg: this.state.error.response.data.message,
                };
            });
        } else {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    errorMsg: "Something Went Wrong, Please Try Again!.",
                };
            });
        }
    }
    render() {
        return <Message variant="danger">{this.state.errorMsg}</Message>;
    }
}
